import { toast } from "react-toastify";

export const notifySuccess = (successInfo) => toast.success(successInfo);
export const notifyError = (errorinfo) => toast.error(errorinfo);
export const notifyWarning = (warningInfo) => toast.warning(warningInfo);
